"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-default-export */
/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable arrow-parens */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable max-len */
const react_1 = __importStar(require("react"));
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const validatorus_react_1 = require("validatorus-react");
const copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
const react_i18next_1 = require("react-i18next");
const de_ui_1 = require("@delab-team/de-ui");
const framer_motion_1 = require("framer-motion");
const bip39_1 = require("bip39");
const ton_crypto_1 = require("ton-crypto");
const pinpad_1 = require("../../components/pinpad");
const svg_selector_1 = require("../../assets/svg-selector");
const auto_complete_input_1 = require("../../components/auto-complete-input");
const wallet_1 = require("../../logic/wallet");
const button_1 = require("../../components/ui/button");
const privacy_1 = require("../settings/privacy");
const security_1 = require("./security");
const welcome_gif_1 = __importDefault(require("../../assets/gifs/welcome.gif"));
const reg_module_css_1 = __importDefault(require("./reg.module.css"));
const getClient_1 = require("../../utils/getClient");
const variants = {
    open: { rotate: 180 },
    closed: { rotate: 0 }
};
const Reg = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const TgObj = sdk_1.default;
    const [createAnimation1, setCreateAnimation1] = (0, react_1.useState)(undefined);
    const [createAnimation2, setCreateAnimation2] = (0, react_1.useState)(undefined);
    const [createAnimation3, setCreateAnimation3] = (0, react_1.useState)(undefined);
    const [createAnimation4, setCreateAnimation4] = (0, react_1.useState)(undefined);
    const [firstRender, setFirstRender] = react_1.default.useState(false);
    const [position, setPosition] = react_1.default.useState(0);
    const [errorWrite24, setErrorWrite24] = react_1.default.useState(false);
    const [errorWrite12, setErrorWrite12] = react_1.default.useState(false);
    const [showTwelve, setShowTwelve] = react_1.default.useState(false);
    const [word24, setWord24] = react_1.default.useState(undefined);
    const [wall, setWall] = react_1.default.useState(undefined);
    const [isCreating, setIsCreating] = react_1.default.useState(false);
    // const [ confirmPassword, setConfirmPassword ] = React.useState<string>('')
    // const [ confirmPasswordImport, setConfirmPasswordImport ] = React.useState<string>('')
    // const [ confirmPasswordPosition, setConfirmPasswordPosition ] = React.useState<number>(0)
    // const [ confirmPasswordPositionImport, setConfirmPasswordPositionImport ] = React.useState<number>(0)
    const [isConfirmedPrivacy, setIsConfirmedPrivacy] = react_1.default.useState(false);
    const [walletVersion, setWalletVersion] = react_1.default.useState(undefined);
    const [isCheckedPrivacy, setIsCheckedPrivacy] = (0, react_1.useState)([false, false, false]);
    const customW = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const wordlist = ton_crypto_1.mnemonicWordList;
    const w1 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w2 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w3 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w4 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w5 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w6 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w7 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w8 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w9 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w10 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w11 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w12 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w13 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w14 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w15 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w16 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w17 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w18 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w19 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w20 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w21 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w22 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w23 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const w24 = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 0, 20).withFname('1');
    const psw = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 4, 160).withFname('Password');
    const [confirmPasswordPosition, setConfirmPasswordPosition] = react_1.default.useState(0);
    const [confirmPasswordPositionImport, setConfirmPasswordPositionImport] = react_1.default.useState(0);
    // const [ confirmPassword, setConfirmPassword ] = React.useState<string>('')
    // const [ confirmPasswordImport, setConfirmPasswordImport ] = React.useState<string>('')
    const confirmPassword = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 4, 160).withFname('confirmPassword');
    const confirmPasswordImport = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 4, 160).withFname('confirmPasswordImport');
    react_1.default.useEffect(() => {
        const storedShowTwelve = localStorage.getItem('showTwelve');
        if (storedShowTwelve !== null) {
            setShowTwelve(JSON.parse(storedShowTwelve));
        }
    }, []);
    async function createWallet() {
        const wall1 = await wallet_1.CustomWallet.newWallet();
        const arr = wall1.mnemonics;
        setWall(wall1);
        setWord24(arr);
        setPosition(2);
    }
    async function createPsw() {
        TgObj.MainButton.showProgress();
        if (!wall || psw.iserr !== 'valid' || !word24) {
            TgObj.MainButton.hideProgress();
            return;
        }
        const hash = await wallet_1.CustomWallet.KeyToHash(word24.join(' '), psw.value);
        if (!hash) {
            return;
        }
        customW.saveWallet({
            iv: hash.iv,
            hashFromKey: hash.hashFromKey,
            publicKey: wall.publicKey,
            address: wall.address
        });
        props.setAddressUser(wall.address);
        customW.setIsPincode();
        TgObj.MainButton.hideProgress();
        window.location.pathname = '/';
    }
    async function loginWallet() {
        TgObj.HapticFeedback.impactOccurred('medium');
        // if (errorWrite12 || errorWrite24) {
        //     return
        // }
        const ww24 = [
            w1.value,
            w2.value,
            w3.value,
            w4.value,
            w5.value,
            w6.value,
            w7.value,
            w8.value,
            w9.value,
            w10.value,
            w11.value,
            w12.value,
            w13.value,
            w14.value,
            w15.value,
            w16.value,
            w17.value,
            w18.value,
            w19.value,
            w20.value,
            w21.value,
            w22.value,
            w23.value,
            w24.value
        ];
        try {
            const isMnem = await (0, ton_crypto_1.mnemonicValidate)(ww24);
            const joinedPhrase = ww24.join(' ').trim();
            const isTrustMnem = await (0, bip39_1.validateMnemonic)(joinedPhrase);
            // if (!isMnem) {
            //     TgObj.showAlert(t('common.mnemonic-error'))
            //     return
            // }
            if (isMnem) {
                const w = await customW.getWalletFromMnemonic(ww24);
                setWall(w);
                setWord24(ww24);
            }
            else if (isTrustMnem) {
                const w = await customW.getWalletFromTrustMnemonic(ww24);
                setWall(w);
                setWord24(ww24);
            }
            else {
                TgObj.showAlert(t('common.mnemonic-error'));
                return;
            }
            setPosition(3);
        }
        catch (error) {
            console.error(error);
        }
    }
    const setVersion = (vers) => {
        customW.saveVersion({ version: vers });
    };
    (0, react_1.useEffect)(() => {
        const initVersion = async () => {
            try {
                const loadData = await customW.loadVersionSaveData();
                console.log('loadData', loadData);
                if (loadData.version) {
                    setWalletVersion(loadData.version);
                }
                else {
                    const res = customW.saveVersion({ version: 'V4' });
                    console.log('res save version V4', res);
                    setWalletVersion('V4');
                    setVersion('V4');
                }
            }
            catch (error) {
                console.error('Error during data retrieval:', error);
            }
            // const res = customW.saveVersion({ version: 'V4' })
            // console.log('res save version')
        };
        initVersion();
    }, []);
    const setVersionHandler = (vers) => {
        setWalletVersion(vers);
        setVersion(vers);
        window.location.reload();
    };
    (0, react_1.useEffect)(() => {
        if (!firstRender) {
            setFirstRender(true);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (w1.iserr === 'valid'
            && w2.iserr === 'valid'
            && w3.iserr === 'valid'
            && w4.iserr === 'valid'
            && w5.iserr === 'valid'
            && w6.iserr === 'valid'
            && w7.iserr === 'valid'
            && w8.iserr === 'valid'
            && w9.iserr === 'valid'
            && w10.iserr === 'valid'
            && w11.iserr === 'valid'
            && w12.iserr === 'valid'
            && w13.iserr === 'valid'
            && w14.iserr === 'valid'
            && w15.iserr === 'valid'
            && w16.iserr === 'valid'
            && w17.iserr === 'valid'
            && w18.iserr === 'valid'
            && w19.iserr === 'valid'
            && w20.iserr === 'valid'
            && w21.iserr === 'valid'
            && w22.iserr === 'valid'
            && w23.iserr === 'valid'
            && w24.iserr === 'valid') {
            setErrorWrite24(false);
            setErrorWrite12(false);
        }
        else {
            showTwelve ? (setErrorWrite12(true)) : (setErrorWrite24(true));
        }
    }, [
        w1.value,
        w2.value,
        w3.value,
        w4.value,
        w5.value,
        w6.value,
        w7.value,
        w8.value,
        w9.value,
        w10.value,
        w11.value,
        w12.value,
        w13.value,
        w14.value,
        w15.value,
        w16.value,
        w17.value,
        w18.value,
        w19.value,
        w20.value,
        w21.value,
        w22.value,
        w23.value,
        w24.value
    ]);
    const distributeWords = (words) => {
        const wordInputs = [
            w1,
            w2,
            w3,
            w4,
            w5,
            w6,
            w7,
            w8,
            w9,
            w10,
            w11,
            w12,
            w13,
            w14,
            w15,
            w16,
            w17,
            w18,
            w19,
            w20,
            w21,
            w22,
            w23,
            w24
        ];
        words.forEach((word, index) => {
            if (index < wordInputs.length) {
                wordInputs[index].change(word);
            }
        });
    };
    const handleFirstInputChange = (word) => {
        w1.change(word);
    };
    const handleAutoCompleteInputChange = (e, onChangeHandler) => {
        const inputContent = e.target.value.trim();
        const words = inputContent.split(/\s+/);
        if (words.length === 1) {
            onChangeHandler(words[0]);
        }
        else {
            distributeWords(words);
        }
    };
    const getFilteredSuggestions = (input, maxSuggestions) => {
        const filteredSuggestions = wordlist.filter(word => word.toLowerCase().includes(input.toLowerCase())).slice(0, maxSuggestions);
        return filteredSuggestions;
    };
    function showBtn() {
        if (position === 2) {
            TgObj.MainButton.show();
            TgObj.MainButton.enable();
            TgObj.MainButton.text = t('reg.im-saved-24-words');
            TgObj.MainButton.color = '#007AFF';
            return;
        }
        if (position === 6) {
            if (!isCheckedPrivacy.every(el => el === true)) {
                TgObj.MainButton.show();
                TgObj.MainButton.text = t('send.enter-amount-position.proceed');
                TgObj.MainButton.color = '#424B56';
                TgObj.MainButton.disable();
                return;
            }
            if (isCreating) {
                TgObj.MainButton.show();
                TgObj.MainButton.color = '#424B56';
                TgObj.MainButton.disable();
                return;
            }
            TgObj.MainButton.show();
            TgObj.MainButton.enable();
            TgObj.MainButton.text = t('send.enter-amount-position.proceed');
            TgObj.MainButton.color = '#007AFF';
            return;
        }
        if (position === 3) {
            TgObj.MainButton.show();
            TgObj.MainButton.text = t('pincod.enter');
            TgObj.MainButton.color = '#424B56';
            TgObj.MainButton.disable();
        }
        // TgObj.MainButton.show()
        // if (!isCreating && confirmPasswordPositionImport === 0) {
        //     TgObj.MainButton.show()
        //     if (psw.value.length < 8 && psw.iserr !== 'valid') {
        //         TgObj.MainButton.text = t('common.enter-a-password')
        //         TgObj.MainButton.color = '#9a9c9a'
        //         TgObj.MainButton.disable()
        //         return
        //     }
        //     TgObj.MainButton.enable()
        //     TgObj.MainButton.text = t('common.enter-a-password2')
        //     TgObj.MainButton.color = '#007AFF'
        // } else if (!isCreating && confirmPasswordPositionImport === 1) {
        //     TgObj.MainButton.show()
        //     if (psw.value.length < 8 || psw.value !== confirmPasswordImport) {
        //         TgObj.MainButton.text = psw.value.length < 8 || psw.value !== confirmPasswordImport ? t('common.confirm-password') : t('common.password-dismatches')
        //         TgObj.MainButton.color = '#9a9c9a'
        //         TgObj.MainButton.disable()
        //         return
        //     }
        //     TgObj.MainButton.enable()
        //     TgObj.MainButton.text = t('common.enter-a-password2')
        //     TgObj.MainButton.color = '#007AFF'
        // } else if (isCreating && confirmPasswordPosition === 0) {
        //     TgObj.MainButton.show()
        //     if (psw.value.length < 8 && psw.iserr !== 'valid') {
        //         TgObj.MainButton.text = t('common.create-a-password')
        //         TgObj.MainButton.color = '#9a9c9a'
        //         TgObj.MainButton.disable()
        //         return
        //     }
        //     TgObj.MainButton.enable()
        //     TgObj.MainButton.text = t('common.create-password')
        //     TgObj.MainButton.color = '#007AFF'
        // } else if (isCreating && confirmPasswordPosition === 1) {
        //     TgObj.MainButton.show()
        //     if (psw.value.length < 8 || psw.value !== confirmPassword) {
        //         TgObj.MainButton.text = psw.value.length < 8 || psw.value !== confirmPassword ? t('common.confirm-password') : t('common.password-dismatches')
        //         TgObj.MainButton.color = '#9a9c9a'
        //         TgObj.MainButton.disable()
        //         return
        //     }
        //     TgObj.MainButton.enable()
        //     TgObj.MainButton.text = t('common.enter-a-password2')
        //     TgObj.MainButton.color = '#007AFF'
        // }
    }
    function handleBackButton() {
        TgObj.HapticFeedback.impactOccurred('medium');
        switch (position) {
            case 1:
            case 2:
                setPosition(0);
                psw.reset(true, true);
                w1.reset(true, true);
                w2.reset(true, true);
                w3.reset(true, true);
                w4.reset(true, true);
                w5.reset(true, true);
                w6.reset(true, true);
                w7.reset(true, true);
                w8.reset(true, true);
                w9.reset(true, true);
                w10.reset(true, true);
                w11.reset(true, true);
                w12.reset(true, true);
                w13.reset(true, true);
                w14.reset(true, true);
                w15.reset(true, true);
                w16.reset(true, true);
                w17.reset(true, true);
                w18.reset(true, true);
                w19.reset(true, true);
                w20.reset(true, true);
                w21.reset(true, true);
                w22.reset(true, true);
                w23.reset(true, true);
                w24.reset(true, true);
                setIsCreating(false);
                break;
            case 3:
                if (isCreating) {
                    if (confirmPasswordPosition === 0) {
                        // setConfirmPassword('')
                        // setConfirmPasswordImport('')
                        confirmPassword.reset(true, true);
                        confirmPasswordImport.reset(true, true);
                        setConfirmPasswordPosition(0);
                        setPosition(2);
                        psw.reset(true, true);
                        TgObj.MainButton.hide();
                    }
                    else if (confirmPasswordPosition === 1) {
                        confirmPassword.reset(true, true);
                        confirmPasswordImport.reset(true, true);
                        setConfirmPasswordPosition(0);
                        setConfirmPasswordPositionImport(0);
                        setPosition(3);
                        psw.reset(true, true);
                        TgObj.MainButton.hide();
                    }
                }
                else if (confirmPasswordPositionImport === 0) {
                    confirmPassword.reset(true, true);
                    confirmPasswordImport.reset(true, true);
                    setConfirmPasswordPosition(0);
                    setPosition(1);
                    psw.reset(true, true);
                    TgObj.MainButton.hide();
                }
                else if (confirmPasswordPositionImport === 1) {
                    confirmPassword.reset(true, true);
                    confirmPasswordImport.reset(true, true);
                    setConfirmPasswordPositionImport(0);
                    setConfirmPasswordPosition(0);
                    psw.reset(true, true);
                    TgObj.MainButton.hide();
                }
                break;
            case 4:
                setPosition(0);
                break;
            case 6:
                setPosition(0);
                confirmPassword.reset(true, true);
                confirmPasswordImport.reset(true, true);
                setConfirmPasswordPositionImport(0);
                setConfirmPasswordPosition(0);
                psw.reset(true, true);
                break;
            default:
                break;
        }
    }
    (0, react_1.useEffect)(() => {
        if (position === 0) {
            TgObj.BackButton.hide();
        }
        else {
            TgObj.BackButton.show();
        }
        // showBackButton()
        TgObj.BackButton.onClick(handleBackButton);
        return () => TgObj.BackButton.offClick(handleBackButton);
    }, [position, confirmPasswordPosition, confirmPasswordPositionImport]);
    // eslint-disable-next-line no-promise-executor-return
    const delay = (delayInms) => new Promise(resolve => setTimeout(resolve, delayInms));
    const handleCheckPsw = async () => {
        if (!isCreating && confirmPasswordPositionImport === 0) {
            setCreateAnimation1('success');
            await delay(250);
            setConfirmPasswordPositionImport(1);
        }
        else if (!isCreating && confirmPasswordPositionImport === 1 && confirmPasswordImport.value.length === 4) {
            if (psw.value === confirmPasswordImport.value) {
                setCreateAnimation2('success');
                await delay(250);
                createPsw();
            }
            else {
                setCreateAnimation2('failure');
            }
        }
        else if (isCreating && confirmPasswordPosition === 0) {
            setCreateAnimation3('success');
            await delay(250);
            setConfirmPasswordPosition(1);
        }
        else if (isCreating && confirmPasswordPosition === 1 && confirmPassword.value.length === 4) {
            if (psw.value === confirmPassword.value) {
                setCreateAnimation4('success');
                await delay(250);
                createPsw();
            }
            else {
                setCreateAnimation4('failure');
            }
        }
    };
    (0, react_1.useEffect)(() => {
        showBtn();
        const handleClick = () => {
            TgObj.HapticFeedback.impactOccurred('medium');
            if (position === 2) {
                TgObj.HapticFeedback.impactOccurred('medium');
                setPosition(3);
                return;
            }
            if (position === 6) {
                TgObj.HapticFeedback.impactOccurred('medium');
                setPosition(2);
                setIsCreating(true);
                createWallet();
            }
            // if (!isCreating && confirmPasswordPositionImport === 0) {
            //     setConfirmPasswordPositionImport(1)
            // } else if (!isCreating && confirmPasswordPositionImport === 1) {
            //     psw.value === confirmPasswordImport && createPsw()
            // } else if (isCreating && confirmPasswordPosition === 0) {
            //     setConfirmPasswordPosition(1)
            // } else if (isCreating && confirmPasswordPosition === 1) {
            //     psw.value === confirmPassword && createPsw()
            // }
        };
        if (position === 3 && (psw.value.length === 4 || confirmPassword.value.length === 4 || confirmPasswordImport.value.length === 4)) {
            handleCheckPsw();
        }
        TgObj.MainButton.onClick(handleClick);
        return () => {
            TgObj.MainButton.offClick(handleClick);
        };
    }, [
        position,
        isCheckedPrivacy,
        isCreating,
        psw,
        confirmPasswordPosition,
        confirmPassword,
        confirmPasswordImport,
        confirmPasswordPositionImport
    ]);
    const wordSuggestions1 = getFilteredSuggestions(w1.value, 3);
    const wordSuggestions2 = getFilteredSuggestions(w2.value, 3);
    const wordSuggestions3 = getFilteredSuggestions(w3.value, 3);
    const wordSuggestions4 = getFilteredSuggestions(w4.value, 3);
    const wordSuggestions5 = getFilteredSuggestions(w5.value, 3);
    const wordSuggestions6 = getFilteredSuggestions(w6.value, 3);
    const wordSuggestions7 = getFilteredSuggestions(w7.value, 3);
    const wordSuggestions8 = getFilteredSuggestions(w8.value, 3);
    const wordSuggestions9 = getFilteredSuggestions(w9.value, 3);
    const wordSuggestions10 = getFilteredSuggestions(w10.value, 3);
    const wordSuggestions11 = getFilteredSuggestions(w11.value, 3);
    const wordSuggestions12 = getFilteredSuggestions(w12.value, 3);
    const wordSuggestions13 = getFilteredSuggestions(w13.value, 3);
    const wordSuggestions14 = getFilteredSuggestions(w14.value, 3);
    const wordSuggestions15 = getFilteredSuggestions(w15.value, 3);
    const wordSuggestions16 = getFilteredSuggestions(w16.value, 3);
    const wordSuggestions17 = getFilteredSuggestions(w17.value, 3);
    const wordSuggestions18 = getFilteredSuggestions(w18.value, 3);
    const wordSuggestions19 = getFilteredSuggestions(w19.value, 3);
    const wordSuggestions20 = getFilteredSuggestions(w20.value, 3);
    const wordSuggestions21 = getFilteredSuggestions(w21.value, 3);
    const wordSuggestions22 = getFilteredSuggestions(w22.value, 3);
    const wordSuggestions23 = getFilteredSuggestions(w23.value, 3);
    const wordSuggestions24 = getFilteredSuggestions(w24.value, 3);
    const hasMatch = (inputValue) => wordlist.some(word => word.toLowerCase() === inputValue.toLowerCase());
    const [inputInFocus1, setInputInFocus1] = (0, react_1.useState)(false);
    const [inputInFocus2, setInputInFocus2] = (0, react_1.useState)(false);
    const [inputInFocus3, setInputInFocus3] = (0, react_1.useState)(false);
    const [inputInFocus4, setInputInFocus4] = (0, react_1.useState)(false);
    const [inputInFocus5, setInputInFocus5] = (0, react_1.useState)(false);
    const [inputInFocus6, setInputInFocus6] = (0, react_1.useState)(false);
    const [inputInFocus7, setInputInFocus7] = (0, react_1.useState)(false);
    const [inputInFocus8, setInputInFocus8] = (0, react_1.useState)(false);
    const [inputInFocus9, setInputInFocus9] = (0, react_1.useState)(false);
    const [inputInFocus10, setInputInFocus10] = (0, react_1.useState)(false);
    const [inputInFocus11, setInputInFocus11] = (0, react_1.useState)(false);
    const [inputInFocus12, setInputInFocus12] = (0, react_1.useState)(false);
    const [inputInFocus13, setInputInFocus13] = (0, react_1.useState)(false);
    const [inputInFocus14, setInputInFocus14] = (0, react_1.useState)(false);
    const [inputInFocus15, setInputInFocus15] = (0, react_1.useState)(false);
    const [inputInFocus16, setInputInFocus16] = (0, react_1.useState)(false);
    const [inputInFocus17, setInputInFocus17] = (0, react_1.useState)(false);
    const [inputInFocus18, setInputInFocus18] = (0, react_1.useState)(false);
    const [inputInFocus19, setInputInFocus19] = (0, react_1.useState)(false);
    const [inputInFocus20, setInputInFocus20] = (0, react_1.useState)(false);
    const [inputInFocus21, setInputInFocus21] = (0, react_1.useState)(false);
    const [inputInFocus22, setInputInFocus22] = (0, react_1.useState)(false);
    const [inputInFocus23, setInputInFocus23] = (0, react_1.useState)(false);
    const [inputInFocus24, setInputInFocus24] = (0, react_1.useState)(false);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const dropdownRef = (0, react_1.useRef)(null);
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const transformValues = showTwelve ? { x: '2%', y: '-50%' } : { x: '-102%', y: '-50%' };
    return ((0, jsx_runtime_1.jsxs)("div", { className: reg_module_css_1.default.regPage, children: [position === 0 ? ((0, jsx_runtime_1.jsxs)("div", { className: reg_module_css_1.default.zeroPosition, children: [(0, jsx_runtime_1.jsxs)("div", { className: reg_module_css_1.default.zeroPositionInner, children: [(0, jsx_runtime_1.jsx)("img", { src: welcome_gif_1.default, alt: "Welcome gif" }), (0, jsx_runtime_1.jsx)(de_ui_1.Title, { variant: "h1", className: reg_module_css_1.default.Title, children: t('reg.title-welcome') }), (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: reg_module_css_1.default.zeroPositionText, children: [t('reg.welcome-text1'), " ", (0, jsx_runtime_1.jsx)("br", {}), " ", t('reg.welcome-text2')] })] }), (0, jsx_runtime_1.jsxs)("div", { className: reg_module_css_1.default.zeroPositionBottom, children: [(0, jsx_runtime_1.jsxs)("div", { className: reg_module_css_1.default.zeroPositionPrivacy, children: [(0, jsx_runtime_1.jsx)("div", { className: `${reg_module_css_1.default.checkbox} ${isConfirmedPrivacy ? reg_module_css_1.default.checkboxChecked : ''}`, onClick: () => {
                                            TgObj.HapticFeedback.impactOccurred('medium');
                                            setIsConfirmedPrivacy(!isConfirmedPrivacy);
                                        }, children: isConfirmedPrivacy && ((0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "checked-2" })) }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { children: (0, jsx_runtime_1.jsx)("span", { onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setPosition(4);
                                            }, children: t('common.continue-you-agree3') }) })] }), (0, jsx_runtime_1.jsx)(button_1.Button, { onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    setPosition(6);
                                }, className: reg_module_css_1.default.createWallet, disabled: !isConfirmedPrivacy || isCreating, children: t('reg.create-wallet') }), (0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: reg_module_css_1.default.importWallet, onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    setPosition(1);
                                    setIsCreating(false);
                                }, disabled: !isConfirmedPrivacy, children: t('reg.import-wallet') })] })] })) : null, position === 1 ? ((0, jsx_runtime_1.jsxs)("div", { className: reg_module_css_1.default.firstPosition, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Title, { variant: "h2", className: `${reg_module_css_1.default.modalTitle}`, children: t('reg.import-wallet2') }), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: reg_module_css_1.default.tabPanel, children: [(0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { className: reg_module_css_1.default.tabButtonDiv, animate: { transform: `translate(${transformValues.x}, ${transformValues.y})` }, transition: { duration: 0.3 } }), (0, jsx_runtime_1.jsx)(button_1.Button, { className: `${reg_module_css_1.default.tabButton}`, onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    setShowTwelve(false);
                                    localStorage.setItem('showTwelve', JSON.stringify(false));
                                }, children: (0, jsx_runtime_1.jsx)(de_ui_1.Text, { children: t('common.24-words') }) }), (0, jsx_runtime_1.jsx)(button_1.Button, { className: `${reg_module_css_1.default.tabButton}`, onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    setShowTwelve(true);
                                    localStorage.setItem('showTwelve', JSON.stringify(true));
                                }, children: (0, jsx_runtime_1.jsx)(de_ui_1.Text, { children: t('common.12-words') }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: reg_module_css_1.default.customSelector, children: [(0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.customSelectorInner}`, onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    setIsOpen(!isOpen);
                                }, ref: dropdownRef, children: [(0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.customSelected}`, children: ["Wallet ", walletVersion] }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.button, { whileHover: { scale: 1.1 }, onClick: () => {
                                            TgObj.HapticFeedback.impactOccurred('medium');
                                            setIsOpen(!isOpen);
                                        }, children: (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { animate: isOpen ? 'open' : 'closed', variants: variants, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "chevron-bottom-white" }) }) })] }), (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: isOpen && ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { initial: { opacity: 0, height: 0 }, animate: { opacity: 1, height: 'auto' }, exit: { opacity: 0, height: 0 }, className: reg_module_css_1.default.dropdown, children: [(0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.action} ${reg_module_css_1.default.actionLangActive} ${walletVersion === 'V4' ? reg_module_css_1.default.selectedSelect : ''}`, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setVersionHandler('V4');
                                            }, children: ["Wallet V4", walletVersion === 'V4' && ((0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "blue-checked" }))] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.action} ${reg_module_css_1.default.actionLang} ${walletVersion === 'V3R1' ? reg_module_css_1.default.selectedSelect : ''}`, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setVersionHandler('V3R1');
                                            }, children: ["Wallet V3R1", walletVersion === 'V3R1' && ((0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "blue-checked" }))] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.action} ${reg_module_css_1.default.actionLang} ${walletVersion === 'V3R2' ? reg_module_css_1.default.selectedSelect : ''}`, onClick: () => {
                                                TgObj.HapticFeedback.impactOccurred('medium');
                                                setVersionHandler('V3R2');
                                            }, children: ["Wallet V3R2", walletVersion === 'V3R2' && ((0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "blue-checked" }))] })] })) })] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w1.value.length > 0 && !hasMatch(w1.value) && !inputInFocus1) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w1.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus1(true), onBlur: () => setInputInFocus1(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "1." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w1.value, onChange: (word) => handleAutoCompleteInputChange({ target: { value: word } }, handleFirstInputChange), suggestions: wordSuggestions1 }, "autocomplete-input-w1")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w2.value.length > 0 && !hasMatch(w2.value) && !inputInFocus2) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w2.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus2(true), onBlur: () => setInputInFocus2(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "2." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w2.value, onChange: newValue => w2.change(newValue), suggestions: wordSuggestions2 }, "autocomplete-input-w2")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w3.value.length > 0 && !hasMatch(w3.value) && !inputInFocus3) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w3.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus3(true), onBlur: () => setInputInFocus3(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "3." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w3.value, onChange: newValue => w3.change(newValue), suggestions: wordSuggestions3 }, "autocomplete-input-w3")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w4.value.length > 0 && !hasMatch(w4.value) && !inputInFocus4) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w4.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus4(true), onBlur: () => setInputInFocus4(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "4." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w4.value, onChange: newValue => w4.change(newValue), suggestions: wordSuggestions4 }, "autocomplete-input-w4")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w5.value.length > 0 && !hasMatch(w5.value) && !inputInFocus5) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w5.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus5(true), onBlur: () => setInputInFocus5(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "5." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w5.value, onChange: newValue => w5.change(newValue), suggestions: wordSuggestions5 }, "autocomplete-input-w5")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w6.value.length > 0 && !hasMatch(w6.value) && !inputInFocus6) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w6.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus6(true), onBlur: () => setInputInFocus6(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "6." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w6.value, onChange: newValue => w6.change(newValue), suggestions: wordSuggestions6 }, "autocomplete-input-w6")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w7.value.length > 0 && !hasMatch(w7.value) && !inputInFocus7) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w7.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus7(true), onBlur: () => setInputInFocus7(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "7." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w7.value, onChange: newValue => w7.change(newValue), suggestions: wordSuggestions7 }, "autocomplete-input-w7")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w8.value.length > 0 && !hasMatch(w8.value) && !inputInFocus8) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w8.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus8(true), onBlur: () => setInputInFocus8(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "8." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w8.value, onChange: newValue => w8.change(newValue), suggestions: wordSuggestions8 }, "autocomplete-input-w8")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w9.value.length > 0 && !hasMatch(w9.value) && !inputInFocus9) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w9.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus9(true), onBlur: () => setInputInFocus9(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "9." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w9.value, onChange: newValue => w9.change(newValue), suggestions: wordSuggestions9 }, "autocomplete-input-w9")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w10.value.length > 0 && !hasMatch(w10.value) && !inputInFocus10) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w10.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus10(true), onBlur: () => setInputInFocus10(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "10." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w10.value, onChange: newValue => w10.change(newValue), suggestions: wordSuggestions10 }, "autocomplete-input-w10")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w11.value.length > 0 && !hasMatch(w11.value) && !inputInFocus11) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w11.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus11(true), onBlur: () => setInputInFocus11(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "11." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w11.value, onChange: newValue => w11.change(newValue), suggestions: wordSuggestions11 }, "autocomplete-input-w11")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w12.value.length > 0 && !hasMatch(w12.value) && !inputInFocus12) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w12.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus12(true), onBlur: () => setInputInFocus12(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "12." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w12.value, onChange: newValue => w12.change(newValue), suggestions: wordSuggestions12 }, "autocomplete-input-w12")] }), !showTwelve && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w13.value.length > 0 && !hasMatch(w13.value) && !inputInFocus13) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w13.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus13(true), onBlur: () => setInputInFocus13(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "13." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w13.value, onChange: newValue => w13.change(newValue), suggestions: wordSuggestions13 }, "autocomplete-input-w13")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w14.value.length > 0 && !hasMatch(w14.value) && !inputInFocus14) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w14.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus14(true), onBlur: () => setInputInFocus14(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "14." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w14.value, onChange: newValue => w14.change(newValue), suggestions: wordSuggestions14 }, "autocomplete-input-w14")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w15.value.length > 0 && !hasMatch(w15.value) && !inputInFocus15) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w15.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus15(true), onBlur: () => setInputInFocus15(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "15." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w15.value, onChange: newValue => w15.change(newValue), suggestions: wordSuggestions15 }, "autocomplete-input-w15")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w16.value.length > 0 && !hasMatch(w16.value) && !inputInFocus16) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w16.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus16(true), onBlur: () => setInputInFocus16(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "16." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w16.value, onChange: newValue => w16.change(newValue), suggestions: wordSuggestions16 }, "autocomplete-input-w16")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w17.value.length > 0 && !hasMatch(w17.value) && !inputInFocus17) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w17.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus17(true), onBlur: () => setInputInFocus17(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "17." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w17.value, onChange: newValue => w17.change(newValue), suggestions: wordSuggestions17 }, "autocomplete-input-w17")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w18.value.length > 0 && !hasMatch(w18.value) && !inputInFocus18) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w18.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus18(true), onBlur: () => setInputInFocus18(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "18." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w18.value, onChange: newValue => w18.change(newValue), suggestions: wordSuggestions18 }, "autocomplete-input-w18")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w19.value.length > 0 && !hasMatch(w19.value) && !inputInFocus19) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w19.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus19(true), onBlur: () => setInputInFocus19(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "19." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w19.value, onChange: newValue => w19.change(newValue), suggestions: wordSuggestions19 }, "autocomplete-input-w19")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w20.value.length > 0 && !hasMatch(w20.value) && !inputInFocus20) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w20.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus20(true), onBlur: () => setInputInFocus20(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "20." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w20.value, onChange: newValue => w20.change(newValue), suggestions: wordSuggestions20 }, "autocomplete-input-w20")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w21.value.length > 0 && !hasMatch(w21.value) && !inputInFocus21) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w21.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus21(true), onBlur: () => setInputInFocus21(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "21." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w21.value, onChange: newValue => w21.change(newValue), suggestions: wordSuggestions21 }, "autocomplete-input-w21")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w22.value.length > 0 && !hasMatch(w22.value) && !inputInFocus22) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w22.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus22(true), onBlur: () => setInputInFocus22(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "22." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w22.value, onChange: newValue => w22.change(newValue), suggestions: wordSuggestions22 }, "autocomplete-input-w22")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w23.value.length > 0 && !hasMatch(w23.value) && !inputInFocus23) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w23.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus23(true), onBlur: () => setInputInFocus23(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "23." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w23.value, onChange: newValue => w23.change(newValue), suggestions: wordSuggestions23 }, "autocomplete-input-w23")] }), (0, jsx_runtime_1.jsxs)("div", { className: `${reg_module_css_1.default.firstPositionInput} ${(w24.value.length > 0 && !hasMatch(w24.value) && !inputInFocus24) ? reg_module_css_1.default.errorInput : ''} ${hasMatch(w24.value) ? reg_module_css_1.default.correct : ''}`, onFocus: () => setInputInFocus24(true), onBlur: () => setInputInFocus24(false), children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: reg_module_css_1.default.firstPositionCount, children: "24." }), ' ', (0, jsx_runtime_1.jsx)(auto_complete_input_1.AutoCompleteInput, { value: w24.value, onChange: newValue => w24.change(newValue), suggestions: wordSuggestions24 }, "autocomplete-input-w24")] })] })), (0, jsx_runtime_1.jsxs)("div", { className: reg_module_css_1.default.firstPositionBtns, children: [(0, jsx_runtime_1.jsx)(button_1.Button, { className: reg_module_css_1.default.createWallet, onClick: () => {
                                    loginWallet();
                                }, children: t('reg.import-wallet2') }), (0, jsx_runtime_1.jsx)(de_ui_1.Button, { onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    setPosition(0);
                                }, className: reg_module_css_1.default.createWalletLink, children: t('common.cancel') })] })] })) : null, position === 2 ? ((0, jsx_runtime_1.jsxs)("div", { className: reg_module_css_1.default.secondPosition, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Title, { variant: "h2", className: `${reg_module_css_1.default.modalTitle}`, children: t('reg.save-24-words') }), (0, jsx_runtime_1.jsx)("div", { className: reg_module_css_1.default.secondPositionCards, children: word24
                            ? word24.map((word, key) => ((0, jsx_runtime_1.jsx)("div", { className: reg_module_css_1.default.secondPositionCard, onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    (0, copy_to_clipboard_1.default)(word24.join(' '));
                                }, children: (0, jsx_runtime_1.jsxs)("button", { children: [key + 1, ". ", word] }) }, key)))
                            : null })] })) : null, position === 3 ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !isCreating ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [confirmPasswordPositionImport === 0 && (
                        // <PasswordInput
                        //     inputTitle={t('common.enter-password') + ' (' + t('common.min-8') + ')'}
                        //     onChange={e => psw.change(e.target.value)}
                        //     placeholder={t('common.password')}
                        // />
                        (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.enter'), onChange: e => psw.change(e), animationState: createAnimation1, setAnimationState: setCreateAnimation1 })), confirmPasswordPositionImport === 1 && (
                        // <>
                        //     <PasswordInput
                        //         inputTitle={t('common.confirm-password')}
                        //         onChange={e => setConfirmPasswordImport(e.target.value)}
                        //         placeholder={t('common.password')}
                        //     />
                        // </>
                        (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.repeat'), onChange: e => confirmPasswordImport.change(e), animationState: createAnimation2, setAnimationState: setCreateAnimation2 }))] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [confirmPasswordPosition === 0 && (
                        // <>
                        //     <PasswordInput
                        //         inputTitle={t('common.create-password') + ' (' + t('common.min-8') + ')'}
                        //         onChange={e => psw.change(e.target.value)}
                        //         placeholder={t('common.password')}
                        //     />
                        // </>
                        (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.create'), onChange: e => psw.change(e), animationState: createAnimation3, setAnimationState: setCreateAnimation3 })), confirmPasswordPosition === 1 && (
                        // <>
                        //     <PasswordInput
                        //         inputTitle={t('common.confirm-password')}
                        //         onChange={e => setConfirmPassword(e.target.value)}
                        //         placeholder={t('common.password')}
                        //     />
                        // </>
                        (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.repeat'), onChange: e => confirmPassword.change(e), animationState: createAnimation4, setAnimationState: setCreateAnimation4 }))] })) })) : null, position === 4 ? ((0, jsx_runtime_1.jsx)(privacy_1.Privacy, {})) : null, position === 6 ? ((0, jsx_runtime_1.jsx)(security_1.Security, { isCheckedPrivacy: isCheckedPrivacy, setIsCheckedPrivacy: setIsCheckedPrivacy })) : null] }));
};
exports.default = Reg;
